import React, { Component } from "react";
import "../../../../SCSS/setup.scss";
import "../../../../SCSS/services.scss";
import Axios from "axios";
import KenTable from "../../../../global_components/KenTable/kentable";
import { withRouter } from "react-router-dom";
import KenPaginationUI from "../../../../global_components/KenPaginator";
// import Loader from "../../../../../utils/loader/loaders";
import ServiceData from "./bankAccounts.json";
import KenForm from "../../../../global_components/KenForm/zqform";
import RestoreOutlinedIcon from "@material-ui/icons/RestoreOutlined";
// import HistoryIcon from "../../../../../assets/icons/history-icon.svg";
import NoteOutlinedIcon from "@material-ui/icons/NoteOutlined";
import KeyboardBackspaceSharpIcon from "@material-ui/icons/KeyboardBackspaceSharp";
import moment from "moment";
// import ZqHistory from "../../../../../gigaLayout/change-history";
import { Drawer } from "rsuite";
import KenContainerNavbar from "../../../../global_components/KenContainerNav";
// import zq_api from "../../../../../utils/api-service";
import Snackbar from '@material-ui/core/Snackbar';
import { Alert } from 'rsuite';
class BankAccounts extends Component {
    constructor(props) {
        super(props);
        // this.zq_api = new zq_api();
        this.state = {
            env: JSON.parse(localStorage.getItem("env")),
            useremail: localStorage.getItem("email"),
            channel: localStorage.getItem("channel"),
            BranchId: localStorage.getItem("branchid"),
            authToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoicHIuYWRtaW4uYWxsQHplbnFvcmUuY29tIiwiVXNlcklkIjoiNjEzMWY3MmM4NTEwMTM1NDIyOTBmMWVhIiwiaWF0IjoxNjMwNjY0ODQ4fQ.X0gWTq-23DBuhjM8Jm-5IEb7fEqsOlRiHU31-HvmNuI",
            orgId: "606ac70479dbb25447375fa8",
            orgName: localStorage.getItem("orgName"),
            userId: localStorage.getItem("userId"),
            username: localStorage.getItem("username"),
            ServiceTableData: [],
            tabview: true,
            preview: true,
            ServiceFormData: ServiceData,
            departmentName: "",
            noProg: "",
            loader: false,
            page: 1,
            limit: 10,
            totalRecord: 0,
            totalPages: 1,
            entityInstanceId: undefined,
            history: false,
            showHistory: false,
            historyData: [],
            submitCheck: false,
            bankName: '',
            containerNav: {
                isBack: false,
                name: "List of Bank Accounts",
                isName: true,
                isSearch: false,
                isSort: false,
                isPrint: true,
                isDownload: false,
                isShare: false,
                isNew: true,
                newName: "New",
                isSubmit: false,
            },
            tabData: [],
            tableResponse: 'Fetching Details...',
            apiCall: false
        };
    }
    componentDidMount() {
        this.getBankAccounts();
    }

    getBankAccounts = () => {
        this.setState({ loader: true })
        var headers = {
            'Authorization': "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoicHIuYWRtaW4uYWxsQHplbnFvcmUuY29tIiwiVXNlcklkIjoiNjEzMWY3MmM4NTEwMTM1NDIyOTBmMWVhIiwiaWF0IjoxNjMwNjY0ODQ4fQ.X0gWTq-23DBuhjM8Jm-5IEb7fEqsOlRiHU31-HvmNuI"
        }
        Axios.get(`https://api.zenqore.com/payroll/uat/hkbk/masters/organizationdetail?org=${this.state.orgId}&page=${this.state.page}&limit=${this.state.limit}`, { headers: headers })
            .then(res => {
                console.log(res.data.data)
                // if (res.data.status == 'success') {
                let tabData = [];
                let data = res.data.data;
                if (data[0].bankReferenceId.length > 0) {
                    data[0].bankReferenceId.map(item => {
                        let createdBy = "-"
                        let personId = ""
                        data[0].loginEmployee.map(loginEmp => {
                            if (item.createdBy == loginEmp.loginReferenceId) {
                                personId = loginEmp.personReferenceId
                            }
                        })
                        data[0].createdPersonInfo.map(loginEmp => {
                            if (personId == loginEmp._id) {
                                createdBy = (String(loginEmp.salutation).length > 1 ? (loginEmp.salutation + ".") : "") + loginEmp.firstName + " " + (loginEmp.lastName != null ? String(loginEmp.lastName).replace("-", "") : "")
                            }
                        })
                        tabData.push({
                            "Bank Name": item.bankName,
                            "Bank IFSC Code": item.bankIFSC,
                            'Bank Account Number': item.bankAccountNumber,
                            'Account Name': item.bankAccountName,
                            'Created By': createdBy,
                            "Version": String('V' + Number(item.__v + 1)),
                            'Status': item.status,
                            "Item": JSON.stringify(item)

                        })
                    })
                    this.setState({
                        loader: false,
                        tabData: tabData,
                        page: res.data.currentPage,
                        limit: res.data.perPage,
                        totalRecord: res.data.totalRecord,
                        totalPages: res.data.totalPages,

                    });
                    if (data.length == 0) {
                        this.setState({ tableResponse: 'No data has been uploaded so far.', loader: false });
                    }
                }
                if (data.length == 0) {
                    this.setState({ tableResponse: 'No data has been uploaded so far.', loader: false });
                }
                // }
            }).catch(err => {
                this.setState({ tableResponse: 'No Data', loader: false });
            })
    }


    // componentWillMount() {
    //     // this.setState({ ServiceFormData: ServiceData }, () => {
    //     if (this.props.location.data != undefined) {
    //         // this.setState({ globalSearch: true }, () => {
    //         this.onPreviewServices(this.props.location.data);
    //         // })
    //     }
    //     // })
    // }


    CreateGoods = () => {
        this.setState({ tabview: false });
    };

    onSubmit = (data, item) => {
        console.log("dataitem", data, item)
        let userData = this.state.ServiceFormData;
        let apiNewCall = true;
        userData.map(item => {
            if (item.requiredBoolean) {
                if (item['defaultValue'] === "" || item['defaultValue'] === undefined || item['error'] || item['defaultValue'] == null) {
                    item["error"] = true;
                    item["validation"] = true
                    item['errorMsg'] = `Invalid ${item.label}`
                    apiNewCall = false
                } else {
                    item["error"] = false;
                    item["validation"] = false;
                }
            }
        })
        this.setState({ ServiceFormData: userData }, () => {
            if (apiNewCall) {
                this.setState({ loader: true }, () => {
                    let payloadInput = {}
                    this.state.ServiceFormData.map(item => {
                        if (item.type != "heading" && item.category != "button") {
                            payloadInput[item.name] = item.defaultValue
                        }
                    })
                    let payload = {
                        "bankName": payloadInput.bankName,
                        "bankIFSC": payloadInput.bankIfsc,
                        "bankAccountNumber": payloadInput.bankAccountNumber,
                        "bankAccountName": payloadInput.accountName,
                        "createdBy": this.state.userId,
                        "updatedBy": this.state.userId,
                        "status": "Active",
                    }
                    console.log("payloadInput", payload)
                    var headers = {
                        'Authorization': localStorage.getItem('auth_token')
                    }
                    if (!this.state.apiCall) {
                        Axios.post(`https://api.zenqore.com/payroll/uat/hkbk/masters/organizationdetail`, payload, { headers: headers })
                            .then(res => {
                                this.setState({ snackBar: true, processMessage: res.data.message }, () => {
                                    setTimeout(() => {
                                        this.setState({ snackBar: false, loader: false, preview: false, tabview: true, previewId: undefined }, () => {
                                            this.getBankAccounts();
                                        })
                                    }, 2000)
                                })
                            }).catch(err => {
                                this.setState({
                                    loader: false
                                }, () => {
                                    this.setState({ snackBar: true, processMessage: err }, () => {
                                        setTimeout(() => {
                                            this.setState({ snackBar: false }, () => {
                                            })
                                        }, 2000)
                                    })
                                });
                            })
                    }
                    else {
                        Axios.put(`https://api.zenqore.com/payroll/uat/hkbk/masters/organizationdetail?id=${this.state.entityInstanceId}`, payload, { headers: headers })
                            .then(res => {
                                this.setState({ snackBar: true, processMessage: res.data.message }, () => {
                                    setTimeout(() => {
                                        this.setState({ snackBar: false, loader: false, preview: false, tabview: true, previewId: undefined }, () => {
                                            this.getBankAccounts();
                                        })
                                    }, 2000)
                                })
                            }).catch(err => {
                                this.setState({
                                    loader: false
                                }, () => {
                                    this.setState({ snackBar: true, processMessage: err }, () => {
                                        setTimeout(() => {
                                            this.setState({ snackBar: false }, () => {
                                            })
                                        }, 2000)
                                    })
                                });
                            })
                    }
                })
            }

        })

    }

    onPreviewServices = (item) => {
        let ServiceFormData = this.state.ServiceFormData;
        let details = JSON.parse(item.Item);
        let objKeys = Object.keys(details);
        let entityInstanceId = details["_id"];
        let bankName = details.bankName
        console.log("details", details);

        this.setState({ tabview: false, preview: true, apiCall: true, entityInstanceId: entityInstanceId, bankName });
        objKeys.map((key) => {
            ServiceFormData.map((item) => {

                // let keyName = key.toLowerCase().replace(/ /g, "");

                // let name = String(details['Department Head']).split()
                // if (item.name == "ID") {
                //     item["defaultValue"] = details['ID'];
                //     item["readOnly"] = false;
                //     item["required"] = false;
                // }
                if (item.name == "bankName") {
                    item["defaultValue"] = details['bankName'];
                    item["readOnly"] = false;
                    item["required"] = false;
                }
                else if (item.name == "bankIfsc") {
                    item["defaultValue"] = details['bankIFSC'];
                    item["readOnly"] = false;
                    item["required"] = false;
                }
                else if (item.name == "bankAccountNumber") {
                    item["defaultValue"] = details['bankAccountNumber'];
                    item["readOnly"] = false;
                    item["required"] = false;
                }
                else if (item.name == "accountName") {
                    item["defaultValue"] = details['bankAccountName'];
                    item["readOnly"] = false;
                    item["required"] = false;
                }

            })
        })
        this.setState({ ServiceFormData });
    };
    onPaginationChange = (page, limit) => {
        this.setState({ page: page, limit: limit }, () => {
            this.getServices();
        });
    };
    resetform = () => {
        let ServiceFormData = this.state.ServiceFormData;
        ServiceFormData.map((item) => {
            item["defaultValue"] = undefined;
            item["readOnly"] = false;
            item["error"] = false;
            item["required"] = item.requiredBoolean
            item["validation"] = false
        });
        this.setState(ServiceFormData);
    };
    onAddServices = () => {
        this.setState({ apiCall: false }, () => {
            this.resetform();
            let ServiceFormData = this.state.ServiceFormData;
            ServiceFormData.map((item) => {
                if (item.name == 'ID') {
                    item["defaultValue"] = '';
                    item["readOnly"] = true;
                    //   item["error"] = false;
                    //   item["required"] = item.requiredBoolean
                    //   item["validation"] = false
                }
            });

            this.setState({ ServiceFormData: ServiceData }, () => {
                this.setState({ tabview: false, preview: false });
            });

        })

    };
    handleBack = () => {
        if (this.props.location.status != "active") {
            this.resetform();
            this.setState({ tabview: true });
        } else {
            this.props.history.goBack();
        }
    };

    onInputChanges = (value, item, e, dataS) => {
        console.log("value", value)
        console.log("item", item)
        console.log("e", e)
        console.log("dataS", dataS)
        if (dataS != undefined) {
            if (dataS["name"] === "type") {
                dataS["defaultValue"] = value;

            }
        }
        else {
            item["defaultValue"] = value
        }

    }

    formBtnHandle = (item) => {
        return item.type === "clear" ? this.cleartabData() : this.canceltabData();
    };
    cleartabData = () => {
        let issueDetailData = [];
        let formData = this.state.ServiceFormData;
        this.setState({ ServiceFormData: [] }, () => {
            formData.map((item) => {
                item["defaultValue"] = undefined;
                item["readOnly"] = false;
                if (item.required) {
                    item["validation"] = false;
                }
            });
            issueDetailData = formData;
            console.log(issueDetailData, "issueDetailData");
            this.setState({
                ServiceFormData: issueDetailData,
            });
        });
    };
    canceltabData = () => {
        this.resetform();
        this.setState({ tabview: true });
    };
    // getChangeHistory = (entityInstanceId) => {
    //     Axios.get(
    //         `${this.state.env["zqBaseUri"]}/master/changeHistory/getChangeHistory?org=${this.state.orgId}&entity=services&entityInstanceId=${entityInstanceId}`
    //     )
    //         .then((response) => {
    //             let api_data = response.data;
    //             let historyData = [];
    //             api_data.sort((data1, data2) => {
    //                 return Number(data2.created_at) - Number(data1.created_at);
    //             });
    //             api_data.map((item) => {
    //                 let date = new Date(
    //                     new Intl.DateTimeFormat("en-US", {
    //                         month: "2-digit",
    //                         day: "numeric",
    //                         year: "numeric",
    //                         hour: "2-digit",
    //                         minute: "2-digit",
    //                     }).format(item["created_at"])
    //                 );
    //                 let descriptionData = item.description["0"]
    //                     .split(",")
    //                     .map((desc, i) => {
    //                         return (
    //                             <p key={i}>
    //                                 <div style={{ display: "flex" }}>
    //                                     <span className="span-hist" style={{ width: "5%" }}>
    //                                         -
    //                                     </span>
    //                                     {desc}
    //                                 </div>
    //                             </p>
    //                         );
    //                     });
    //                 console.log(descriptionData);
    //                 historyData.push({
    //                     description: descriptionData,
    //                     time: moment(date).format("hh:mm"),
    //                     created_at: item["created_at"]
    //                         ? moment(date).format("DD/MM/YYYY (hh:mm A)")
    //                         : "-",
    //                     version: item.version,
    //                     btn: false,
    //                 });
    //             });
    //             this.setState({ historyData: historyData });
    //         })
    //         .catch((err) => {
    //             console.log(err);
    //         });
    // };
    // showHistory = () => {
    //     this.setState({ history: true, showHistory: true });
    // };
    // onCloseForm = () => {
    //     this.setState({ showHistory: false });
    // };
    render() {
        return (
            <React.Fragment>
                {/* {this.state.loader ? <Loader /> : null} */}
                <div className="setup-page-wrapper">
                    {this.state.tabview ? (
                        <React.Fragment>
                            {this.state.containerNav == undefined ? null : (
                                <React.Fragment>
                                    <KenContainerNavbar
                                        containerNav={this.state.containerNav}
                                        onAddNew={() => {
                                            this.resetform();
                                            this.onAddServices();
                                        }}
                                    />
                                    <div className="print-time">{this.state.printTime}</div>
                                </React.Fragment>

                            )}
                            <div className="trial-balance-header-title">
                                <KeyboardBackspaceSharpIcon className="keyboard-back-icon" onClick={() => { this.props.history.push('/main/dashboard') }} style={{
                                    marginRight: '5px',
                                    cursor: 'pointer',
                                    marginTop: '0px'
                                }} />
                                <p className="top-header-title" onClick={() => { this.props.history.push('/main/dashboard') }}>| Bank Accounts</p>
                            </div>
                            <div
                                className="table-wrapper"
                                style={{ marginTop: "10px" }}
                            >
                                {this.state.tabData.length == 0 ||
                                    this.state.loader ? (
                                    <p className="noprog-txt">{this.state.tableResponse}</p>
                                ) : (
                                    <React.Fragment>
                                        <div className="remove-last-child-table">
                                            <KenTable
                                                data={this.state.tabData}
                                                rowClick={(item) => {
                                                    this.onPreviewServices(item);
                                                }}
                                            />
                                        </div>
                                    </React.Fragment>
                                )}
                                <div className="setup-pagination">
                                    {this.state.tabData.length !== 0 && (
                                        <KenPaginationUI
                                            total={this.state.totalRecord}
                                            onPaginationApi={this.onPaginationChange}
                                            totalPages={this.state.totalPages}
                                            limit={this.state.limit}
                                        />
                                    )}
                                </div>
                            </div>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <div className="tab-form-wrapper">
                                <div className="goods-btns services-btns">
                                    <div className="preview-header-wrap">
                                        <div className="trial-balance-header-title">
                                            <KeyboardBackspaceSharpIcon className="keyboard-back-icon" onClick={this.handleBack} style={{
                                                marginRight: '5px',
                                                cursor: 'pointer',
                                                marginTop: '0px'
                                            }} />
                                            {this.state.preview ?
                                                <p className="top-header-title" onClick={this.handleBack}>| Bank Accounts | {this.state.bankName}</p> :
                                                <p className="top-header-title" onClick={this.handleBack}>| Bank Accounts </p>}
                                        </div>
                                        {/* {this.state.preview ? (
                                                <React.Fragment>
                                                    <div
                                                        className="active-status-wrapper"
                                                        style={{ marginLeft: "10px" }}
                                                    >
                                                        <p className="active-status-content">Active</p>
                                                    </div>
                                                </React.Fragment>
                                            ) : null} */}
                                    </div>

                                </div>
                                <div className="goods-wrapper service-wrapper form-heading-tab">

                                    <KenForm
                                        formData={this.state.ServiceFormData}
                                        className="goods-wrap"
                                        onInputChanges={this.onInputChanges}
                                        onFormBtnEvent={(item) => {
                                            this.formBtnHandle(item);
                                        }}
                                        clear={true}
                                        onSubmit={this.onSubmit}
                                    />
                                </div>

                            </div>
                        </React.Fragment>
                    )}
                </div>
                {/* {this.state.history ? (
                    <Drawer show={this.state.showHistory} onHide={this.close}>
                        <ZqHistory
                            historyData={this.state.historyData}
                            onCloseForm={this.onCloseForm}
                        />
                    </Drawer>
                ) : null} */}
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={this.state.snackBar}
                    autoHideDuration={1000}
                    message={this.state.processMessage}
                    className="success-snackbar"

                />
            </React.Fragment>
        );
    }
}
export default withRouter(BankAccounts);
